module.exports = __webpack_public_path__ + "img/west-vvip-gal-6.47c8b1f3.jpg";